module.exports = __webpack_public_path__ + "img/16.96a7a3c4.png";